import { render, staticRenderFns } from "./KnowledgeComponent.vue?vue&type=template&id=2507d90c"
import script from "./KnowledgeComponent.vue?vue&type=script&lang=js"
export * from "./KnowledgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports